import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { SpProgram } from '@session';
import { PasswordPolicy, PasswordResponse } from '@model/password/password-policy';
import { UrlFns } from '@core/utils/url-fns';
const passwordPolicyUrl = UrlFns.getApiRoot() + '/register/user/password';


@Injectable({ providedIn: 'root' })
export class PasswordService {
  program: SpProgram;

  constructor(private http: HttpClient) {
  }

  //
  // Obtains the password policy for the current user context's indicated program.
  getPolicy(programcode: string): Observable<PasswordPolicy> {
    return this.http.get<PasswordResponse>(passwordPolicyUrl + '/' + programcode).pipe(
      map(response=> {
        const policy = new PasswordPolicy();
        policy.hydrateFrom(response.policy);
        return policy;
      })
    );
  }
}